import CardKeyDemo from '../components/CardKeyDemo';
import Page from '../components/Page';
import { CAROUSEL_TYPES } from '../constants/carouselTypes';
import { useAppStore } from '../stores/useAppStore';
import { AnimatePresence } from 'motion/react';
import { useDoubleClick } from '../hooks/useDoubleClick';

function PageKeyDemos() {
  const { content: { lets_talk_strategy: content }, setCardTouchPos, toggleHomeQR } = useAppStore();
  const { openCarousel } = useAppStore((state) => state.carousel);

  const items = content?.items;

  // Handler para doble click/tap en el título para mostrar QR
  const handleTitleDoubleClick = useDoubleClick(() => {
    toggleHomeQR();
  });

  const handleCardClick = (event, index) => {
    event.preventDefault();
    event.stopPropagation();

    let x, y;

    if (event.touches) {
      // Evento táctil
      x = event.touches[0].clientX;
      y = event.touches[0].clientY;
    } else {
      // Evento de ratón
      x = event.clientX;
      y = event.clientY;
    }
    setCardTouchPos({x, y});
    
    openCarousel(index, CAROUSEL_TYPES.KEY_DEMOS);
  };

  // Mostrar loading o mensaje si no hay items
  if (!items || items.length === 0) {
    return (
      <Page className='flex items-center justify-center pl-64 pr-[13.75rem]'>
        <div className="text-white text-2xl">
          {!content ? 'Loading...' : ''}
        </div>
      </Page>
    );
  }

  return (
    <Page className='flex space-between overflow-hidden pr-16u relative' paddingLeft={0} paddingLeftCollapsed={0}>
      <div 
        className='absolute aspect-16-9:top-320u not-aspect-16-9:top-400u left-1/2 text-120u font-extralight -translate-x-1/2 z-30 cursor-pointer'
        onClick={handleTitleDoubleClick}
      >
        {content?.title}
      </div>
      <div className='absolute aspect-16-9:top-487u not-aspect-16-9:top-587u left-1/2 text-48u font-light -translate-x-1/2'>
        {content?.subtitle}
      </div>
      <div className='grid grid-cols-[repeat(2,_min-content)] landscape:grid-cols-[repeat(3,_min-content)] auto-rows-min
      aspect-16-9:gap-x-142u aspect-16-9:gap-y-135u
      not-aspect-16-9:gap-x-182u not-aspect-16-9:gap-y-175u
      justify-center content-start
      h-full w-full
      aspect-16-9:pt-714u not-aspect-16-9:pt-864u
      overflow-hidden relative'>
        <AnimatePresence>
          {items.map((item, index) => (
            <CardKeyDemo
              key={item.id}
              item={item}
              index={index}
              onClick={(event) => handleCardClick(event, index)}
            />
          ))}
        </AnimatePresence>
      </div>
    </Page>
  );
}

export default PageKeyDemos;